import React from 'react';
import { BaseMenuItem, BaseMenuItemProps } from './BaseMenuItem';
import { MenuItemAction } from './MenuItemAction';
import { MenuItemRightIcon } from './MenuItemRightIcon';

export type MenuItemProps = Omit<
  BaseMenuItemProps,
  'closeOnClick' | 'highlighted'
> & {
  forceHighlight?: boolean;
};

type MenuItemComponent = React.FC<MenuItemProps> & {
  Action: typeof MenuItemAction;
  RightIcon: typeof MenuItemRightIcon;
};

const MenuItemComponent: MenuItemComponent = ({ forceHighlight, ...props }) => (
  <BaseMenuItem {...props} closeOnClick={true} highlighted={forceHighlight} />
);

MenuItemComponent.Action = MenuItemAction;
MenuItemComponent.RightIcon = MenuItemRightIcon;

MenuItemComponent.displayName = 'MenuItem';

export const MenuItem = MenuItemComponent;
